<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {ArrowLeftIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue";
import Feed from "@/Shared/Feed.vue";
import {Link, router, useForm, usePage} from "@inertiajs/vue3";
import {useAdStore} from "@/Stores/AdStore.js";
import {SignalIcon} from "@heroicons/vue/24/outline/index.js";
import {useAdSenseNavigation} from "@/Composables/useAdSenseNavigation";

const props = defineProps({
	collection: Object,
	posts: Object, // Paginated posts from Inertia::scroll()
	current: Number, // Post index in the posts array
	back_url: String,
});

const adStore = useAdStore();
const form = useForm({});
const { onPostActive } = useAdSenseNavigation();
const user = ref(usePage().props.auth.user);
const settings = ref(usePage().props.settings);

const follow_unfollow = () => {
	if (user.value) {
		form.post(route('collections.follow', props.collection.uuid), {
			onSuccess: () => {
				router.reload({
					only: ['collection'],
					preserveScroll: true,
					preserveState: true,
				})
			}
		})
	} else {
		// signup
		router.visit(route('register'))
	}
}

</script>
<template>
	<AppLayout>

		<div v-if="!adStore.isShow"
		     class="absolute w-full z-10 p-4 space-x-4 flex flex-row justify-between items-center exclude-poppit">

			<Link :href="back_url" aria-label="Go Back">
				<ArrowLeftIcon class="h-6 text-white drop-shadow"/>
			</Link>

			<button
				class="flex items-center space-x-1 text-lg bg-white py-1 px-2 rounded-lg shadow text-dark-900 font-bold"
				@click="follow_unfollow">
				<span v-if="!collection.stats.followed">Follow</span>
				<span v-else>Unfollow</span>
				<span> {{ collection.name }}</span>
			</button>

			<Link v-if="settings.live_models_feed_enabled" :href="route('live')"
			      class="text-white flex flex-col items-center justify-center space-y-0.5 hover:bg-white hover:bg-opacity-30 rounded-full w-12 h-12">
				<SignalIcon class="h-5"/>
				<span class="bg-white rounded text-[6pt] text-black px-0.5">Live</span>
			</Link>
		</div>

		<Feed :posts="posts" :current="current" @post-active="onPostActive" />
	</AppLayout>
</template>
